import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const Section = ({ n, title, children }) => (
  <section className="mt-6" data-testid={`cgv-section-${n}`}>
    <h2 className="font-heading text-lg md:text-xl font-bold text-slate-900">{n}. {title}</h2>
    <div className="mt-2 text-sm text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

export default function CGV() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/site-settings").then((r) => setS(r.data || {})).catch(() => {}); }, []);
  const company = s.legal_company || "PROXIreduc-28";
  const siret = s.legal_siret || "—";
  const email = s.contact_email || "info.proxireduc@gmail.com";

  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid="cgv-page">
      <h1 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">Conditions Générales de Vente — Partenaires professionnels</h1>
      <p className="mt-2 text-sm text-slate-500">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>

      <div className="mt-4 rounded-xl bg-amber-50 border border-amber-200 p-3 text-xs text-amber-800">
        Ces CGV encadrent la souscription des abonnements professionnels PROXIreduc-28. Elles doivent être validées par votre conseil juridique avant mise en production commerciale.
      </div>

      <Section n="1" title="Objet">
        <p>Les présentes Conditions Générales de Vente (CGV) régissent les relations entre {company} (ci-après « PROXIreduc-28 ») et tout professionnel (ci-après « le Partenaire ») souscrivant à un abonnement payant sur la plateforme PROXIreduc-28, dédiée à la mise en avant de bons plans locaux en Eure-et-Loir.</p>
      </Section>
      <Section n="2" title="Éditeur">
        <p>{company}{siret !== "—" ? ` — SIRET ${siret}` : ""}. Contact : {email}.</p>
      </Section>
      <Section n="3" title="Formules et prix">
        <p>PROXIreduc-28 propose une fiche gratuite ainsi que des formules payantes : <b>Essentiel (9,90 €/mois)</b>, <b>Visibilité (19,90 €/mois)</b> et <b>Premium (29,90 €/mois)</b>. Les prix en vigueur sont ceux affichés sur la page « Devenir partenaire » au moment de la souscription. TVA non applicable, art. 293 B du CGI.</p>
      </Section>
      <Section n="4" title="Essai gratuit">
        <p>La formule Visibilité peut être proposée avec un essai gratuit de 30 jours pour toute première souscription. Aucun montant n'est prélevé pendant la période d'essai. À l'issue de l'essai, l'abonnement est automatiquement facturé au tarif en vigueur, sauf résiliation avant la fin de l'essai.</p>
      </Section>
      <Section n="5" title="Souscription et paiement">
        <p>Le paiement s'effectue en ligne par carte bancaire via notre prestataire de paiement sécurisé Stripe. PROXIreduc-28 ne stocke aucune donnée bancaire. L'abonnement est mensuel et reconduit automatiquement par tacite reconduction.</p>
      </Section>
      <Section n="6" title="Activation du service">
        <p>Après confirmation du paiement par le prestataire, le compte Partenaire est activé et donne accès aux fonctionnalités de la formule choisie (création d'offres dans la limite du quota, statistiques, mise en avant, etc.).</p>
      </Section>
      <Section n="7" title="Durée, renouvellement et résiliation">
        <p>L'abonnement est conclu sans engagement de durée minimale et renouvelé mensuellement. Le Partenaire peut résilier à tout moment depuis son espace (« Mon abonnement » → portail de gestion). La résiliation prend effet à la fin de la période en cours ; aucun remboursement au prorata n'est effectué pour la période entamée.</p>
      </Section>
      <Section n="8" title="Échec de paiement">
        <p>En cas d'échec de prélèvement, le Partenaire en est informé et dispose d'un délai pour régulariser via la mise à jour de son moyen de paiement. À défaut, l'accès aux fonctionnalités payantes peut être suspendu.</p>
      </Section>
      <Section n="9" title="Factures">
        <p>Une facture est émise pour chaque paiement et accessible depuis l'espace Partenaire (« Mes factures »).</p>
      </Section>
      <Section n="10" title="Obligations du Partenaire">
        <p>Le Partenaire garantit l'exactitude des informations de sa fiche et de ses offres, leur conformité à la réglementation (prix, réductions, conditions), et dispose des droits sur les contenus publiés (textes, logos, photos). Les offres sont soumises à validation de PROXIreduc-28 avant publication.</p>
      </Section>
      <Section n="11" title="Droit de rétractation">
        <p>Conformément au droit applicable, le droit de rétractation de 14 jours prévu pour les consommateurs ne s'applique pas aux contrats conclus entre professionnels (B2B). Les présentes CGV s'adressent exclusivement à des professionnels.</p>
      </Section>
      <Section n="12" title="Responsabilité">
        <p>PROXIreduc-28 fournit un service de visibilité et de diffusion. Aucune garantie de résultat commercial (nombre de clients ou de ventes) n'est donnée. PROXIreduc-28 ne saurait être tenu responsable des relations entre le Partenaire et les bénéficiaires des offres.</p>
      </Section>
      <Section n="13" title="Données personnelles">
        <p>Le traitement des données est décrit dans la <a href="/confidentialite" className="text-[#E05638] underline">politique de confidentialité</a>.</p>
      </Section>
      <Section n="14" title="Droit applicable et litiges">
        <p>Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée avant toute action judiciaire ; à défaut, les tribunaux compétents seront saisis.</p>
      </Section>
    </div>
  );
}
